import React from 'react';
export function Footer() {
  return <footer className="py-12 md:py-16 border-t border-pink-200 bg-white/40 backdrop-blur-sm" data-id="element-17">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-18">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white shadow-sm border border-pink-200 text-fuchsia-600 text-sm font-bold tracking-wider mb-6" data-id="element-19">
          MEGA PACK MAMÁ PRIMERIZA™
        </div>

        <p className="text-gray-800 font-medium text-base md:text-lg mb-2" data-id="element-20">
          El sistema N°1 para mamás primerizas en Argentina.
        </p>
        <p className="text-gray-600 text-sm md:text-base mb-10" data-id="element-21">
          Porque prepararse para el embarazo y la maternidad no debería costarte
          meses de ansiedad, información contradictoria y noches de búsquedas
          que te generan más miedo que certeza.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-sm text-gray-500 mb-10" data-id="element-22">
          <a href="mailto:soportenexorecursos@gmail.com" className="hover:text-fuchsia-600 transition-colors font-medium" data-id="element-23">
            📧 soportenexorecursos@gmail.com
          </a>
          <span className="hidden md:inline text-gray-300" data-id="element-24">|</span>
          <a href="https://mama.nexorecursos.com" target="_blank" rel="noopener noreferrer" className="hover:text-fuchsia-600 transition-colors font-medium" data-id="element-25">
            🌐 mama.nexorecursos.com
          </a>
        </div>

        <div className="text-gray-500 text-xs md:text-sm space-y-1 mb-12" data-id="element-26">
          <p data-id="element-27">
            © Mega Pack Mamá Primeriza™ 2025 — Todos los derechos reservados.
          </p>
          <p data-id="element-28">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <div className="pt-8 border-t border-pink-200/60" data-id="element-29">
          <p className="text-gray-600 italic font-medium text-sm md:text-base" data-id="element-30">
            "Tu embarazo merece información real, en orden y en tu idioma. El
            sistema está acá. Solo falta que lo abras."
          </p>
        </div>
      </div>
    </footer>;
}